module.exports = __webpack_public_path__ + "static/media/time-in-germany.8b70f891.jpg";